import { LifeBuoyIcon } from 'lucide-react'

import { useSupportUnreadCount } from '@/modules/support/store'
import { cn } from '@/utils'
import { openHelp } from '../openHelp'

export const GetHelpNavItem = () => {
  const unreadCount = useSupportUnreadCount()

  return (
    <button
      type="button"
      onClick={openHelp}
      aria-label={unreadCount > 0 ? 'Get help, support replied' : 'Get help'}
      className={cn(
        'group flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-blue-7 outline-none transition-colors cursor-pointer',
        'hover:bg-muted/50 hover:text-foreground',
        'focus-visible:ring-2 focus-visible:ring-brand/20',
      )}
    >
      <LifeBuoyIcon className="h-4 w-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground" />
      <span className="truncate text-pretty">Get help</span>
      {unreadCount > 0 && (
        <span className="relative ml-auto flex h-2 w-2 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand/60 motion-reduce:hidden" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-brand" />
        </span>
      )}
    </button>
  )
}
